import { Flex } from "@chakra-ui/react";
import React from "react";
import type { IHeaderProps } from "..";
import Menu from "./Menu";
import { observer } from "mobx-react-lite";

const HeaderMobile: React.FC<IHeaderProps> = observer(({ contents }) => (
	<Flex h={"56px"} w={"100%"} bg={"white"}>
		<Menu contents={contents} />
	</Flex>
));

export default HeaderMobile;
